<template>
  <div class="mt-8 flex justify-end px-24 pb-24">
    <PaymentSubmitButton v-if="formVersion === 'v1'" :form />
    <PaymentSubmitButtonVNext v-else :form />
  </div>
</template>

<script setup lang="ts">
import { usePaymentFormVersion } from '../../../form-common/composables/usePaymentFormVersion'
import type { PaymentFormInstance } from '../../../form-common/types/PaymentFormInstance'

import PaymentSubmitButton from './PaymentSubmitButton.vue'
import PaymentSubmitButtonVNext from './PaymentSubmitButtonVNext.vue'

defineProps<{
  form: PaymentFormInstance | null
}>()

const formVersion = usePaymentFormVersion()
</script>
